import { Box } from '@palmetto/palmetto-components';
import { useEffect, useMemo } from 'react';
import { NavLink, Route, Routes, useParams, useNavigate } from 'react-router-dom';

import { itcModifierMap, ModifierType, ProgramType } from 'types';

import { SpecificITCModifier } from './SpecificITCModifier';

export const ITCModifiers = () => {
  const navigate = useNavigate();
  const { programType, modifierType } = useParams<{ programType: string; modifierType: string }>();
  const availableItcModifierMap = useMemo(() => {
    if (programType === ProgramType.geothermal) {
      return {
        [ModifierType.energyCommunity]: itcModifierMap[ModifierType.energyCommunity],
      };
    }
    return itcModifierMap;
  }, [programType]);

  // if no modifier selected, use first one, if invalid modifier selected, redirect to main modifiers page
  useEffect(() => {
    if (!modifierType || !availableItcModifierMap[modifierType as ModifierType]) {
      const modifier = Object.keys(availableItcModifierMap)[0];
      navigate(`/admin/pricing/${programType}/itc-modifiers/${modifier}`, { replace: !!modifierType });
    }
  }, [availableItcModifierMap, modifierType, navigate, programType]);

  return (
    <Box direction="row" childGap="3xl">
      <Box>
        {Object.keys(availableItcModifierMap).map((type) => (
          <NavLink
            to={`/admin/pricing/${programType}/itc-modifiers/${type}`}
            style={{ textDecoration: 'none', fontWeight: '500' }}
            key={type}
            end
          >
            {({ isActive }) => (
              <Box
                as="span"
                padding="md"
                className={isActive ? 'tab-active' : ''}
                hover={{ color: 'primary' }}
                style={{ transitionDuration: '0s', borderBottom: 0 }}
              >
                {availableItcModifierMap[type as ModifierType]}
              </Box>
            )}
          </NavLink>
        ))}
      </Box>
      <Box flex="auto">
        <Routes>
          <Route path="/:modifierType?" element={<SpecificITCModifier />} />
        </Routes>
      </Box>
    </Box>
  );
};
